<template>
  <div
    class="layout layout--full-center c-white bg-gray-900 flex-col py-xl justify-center relative"
    :style="styles"
  >
    <figure class="responsive-image absolute pin z-0 no-overflow">
      <img
        :style="{
          transition: 'transform 200ms ease-out, opacity 200ms ease-out',
          ...imgStyles,
        }"
        class="object-cover object-center-1/3"
        src="/themes/sloan/img/rendering-repository/hero.jpg"
      />
    </figure>
    <div class="container z-1">
      <div class="row items-center">
        <div class="col xs:col-12 sm:col-8 md:col-6 mx-auto flex-col">
          <div class="flex-col justify-center my-auto">
            <div v-show="!searchActive" class="element element--text-hero text-center">
              <h1 class="text-3xl md:text-4xl">Sloan Image Library</h1>
              <div
                class="text-lg md:text-xl optimize-width flex-col stack-lg mt-sm md:mt-md"
              >
                <p>
                  {{ 'Search Sloan’s extensive image library to inspire your next project' | t }}
                </p>
              </div>
            </div>
            <div
              :class="{
                'mt-xl': !searchActive,
                '-mb-3xl': searchActive,
              }"
            >
              <search-box :autofocus="true" @input="updateQuery($event)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from './SearchBox.vue';
import t from '../../main/i18n';

export default {
  components: {SearchBox},
  props: {
    searchActive: {type: Boolean, default: false}
  },
  filters: {
    t
  },
  computed: {
    styles() {
      if (this.searchActive) return {};
      const ratio = 5 / 7;
      return {
        'min-height': '540px',
        height: 'calc(45vw * ' + ratio.toFixed(4) + ')',
        'max-height': '960px'
      };
    },
    imgStyles() {
      if (!this.searchActive) {
        return {
          opacity: 1,
          transform: 'scale(1)'
        };
      }
      return {
        opacity: 0,
        transform: 'scale(1.125)'
      };
    }
  }
};
</script>
